module.exports = __webpack_public_path__ + "img/Skram_Karens_jul.6a64c091.jpg";